module.exports = __webpack_public_path__ + "static/renaissance-logo-4b7227a4e4efb6825083663019d8245c.svg";